var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChecksEmpty = function SvgChecksEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 114",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M0.5 0.5L0.5 113.5 83.5 113.5 83.5 33.5 49.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M49.5 0.5L49.5 33.5 83.5 33.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 44.972l24 8.17V79.5c0 7.749-11.148 16.285-23.428 20.34l-.572.185-.572-.185c-12.14-4.01-23.174-12.398-23.424-20.076L16 79.5V53.142l24-8.17zm0 1.056l-23 7.83V79.5c0 6.834 9.863 14.697 21.108 18.82l.815.292.819.278.258.084.258-.084C51.888 95.05 62.498 87.044 62.983 80l.013-.252L63 79.5V53.858l-23-7.83zm10.271 14.993l.708.708-9.772 9.771 9.772 9.771-.708.708-9.772-9.772-9.77 9.772-.708-.708 9.771-9.77-9.77-9.772.707-.708 9.77 9.771 9.772-9.77z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChecksEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "checks-empty.6e5f0bad7bd4b33b0c0e1bde39c1057c.svg";